import { Address } from '@dehaat/kisan-app-bl/models/AddressV2'
import { Vendor } from '@dehaat/kisan-app-bl/models/Vendor'
import { ProductVariant } from 'src/models/Product'
import { CartStateInStorage } from 'src/models/Product'

import { CART_TYPE } from '@/constants/cart'
import { MY_CART } from '@/constants/common'
import { InsuranceDataItem } from '@/models/api/productInsurance'
import { AvailableCoupon, FetchCouponDetailsResponse } from '@/models/Coupon'
import { post } from '@/utils/axios'


export interface FetchCouponPayload {
  address: Address | null
  vendor: Vendor
  variants: ProductVariant[]
  idKycStatus: boolean
  bankKycStatus: boolean
  totalVariantCost: number
  totalInsuranceCost: number
  totalDiscount: number
  shippingCharges: number
  insuranceData: InsuranceDataItem[]
  isCreditPayment: boolean
  coupon: AvailableCoupon | null
  cartId?: string
}

export const fetchCouponDetails = async (
  payload: FetchCouponPayload
): Promise<FetchCouponDetailsResponse> => {
  let cartId = ''
  try {
    const raw = localStorage.getItem(MY_CART)
    if (raw) {
      const parsed: CartStateInStorage = JSON.parse(raw)
      cartId = parsed?.[CART_TYPE.DEHAAT]?.cartId || ''
    }
  } catch (e) {
    console.warn('Failed to parse cart from localStorage', e)
  }

  return post<FetchCouponDetailsResponse>(
    '/hyperlocal/v1/fetch-coupon-details',
    {
      ...payload,
      cartId: payload.cartId || cartId,
    }
  )
}
